import React from 'react';
import { countAnswers, scrollUp } from '../../../components/helpers';
import { spiritualGifts, DISC, sacredPath } from './surveysQuestions';
import { leadersImmersionQuestions } from './surveysQuestions/additionalQuestions';
import { Button } from 'semantic-ui-react';
import moment from 'moment';
import { Margin, usePDF } from 'react-to-pdf';
import { renderAnswers } from 'src/components/helpers/renderFormAnswers';
import { CrecerResultsContainer } from 'src/assets/styles/components/clase3Answers';

const getInterpretation = (source, answers, position) =>
  source.find((a) => a.letter === answers[position].letter);

export const showSpiritualGifts = (source, answers, position) => {
  const interpretation = getInterpretation(source, answers, position);
  if (!interpretation) return null;

  return (
    <article className="result-item" key={`${interpretation.gift}-${position}`}>
      <div className="result-item__header">
        <h3 className="result-item__title">{interpretation.gift}</h3>
        <span className="result-item__score">
          Total: <strong>{answers?.[position]?.grade ?? ''}</strong>
        </span>
      </div>
      <div
        className="result-item__body"
        dangerouslySetInnerHTML={{
          __html: interpretation.text,
        }}
      />
    </article>
  );
};

const discLetter = (letter) => {
  if (letter === 'd') return `D - Determinante`;
  if (letter === 'i') return `I - Influyente`;
  if (letter === 's') return `S - Sereno`;
  if (letter === 'c') return `C - Consciente`;
  return '-';
};

export const DISCResults = (DISCAnswers) => {
  if (!DISCAnswers?.[0]?.letter) return null;

  const primary = DISCAnswers[0];
  const secondary = DISCAnswers[1];
  const primaryText = DISC?.find((a) => a.letter[0] === primary.letter && !a.letter[1])?.text;
  const comboText = secondary
    ? DISC?.find((a) => a?.letter?.[0] === primary?.letter && a?.letter[1] === secondary?.letter)
        ?.text
    : null;

  return (
    <section className="DISC result-section">
      <header className="result-section__header">
        <p className="result-section__eyebrow">Personalidad</p>
        <h2>La forma como te conectas con las personas</h2>
      </header>

      <div className="disc-primary">
        <div className="disc-letter" aria-label={discLetter(primary.letter)}>
          <span className="disc-letter__char">{String(primary.letter).toUpperCase()}</span>
          <span className="disc-letter__label">{discLetter(primary.letter)}</span>
        </div>
        {primaryText && (
          <div className="result-item__body" dangerouslySetInnerHTML={{ __html: primaryText }} />
        )}
      </div>

      {secondary?.letter && (
        <div className="disc-combo">
          <div className="disc-combo__badge">
            <span className="disc-combo__letters">
              {String(primary.letter).toUpperCase()}/{String(secondary.letter).toUpperCase()}
            </span>
            <span className="disc-combo__names">
              {discLetter(primary.letter)} / {discLetter(secondary.letter)}
            </span>
          </div>
          {comboText && (
            <div className="result-item__body" dangerouslySetInnerHTML={{ __html: comboText }} />
          )}
        </div>
      )}
    </section>
  );
};

const CrecerSurveyAnswers = (props) => {
  const { answer, set_showAnswers } = props;
  const spiritualGiftAnswers = countAnswers(answer.CrecerSurveys[0].spiritualGiftAnswers);
  const experienceWithGodAnswers = countAnswers(answer.CrecerSurveys[0].experienceWithGodAnswers);
  const DISCAnswers = countAnswers(answer.CrecerSurveys[0].DISCAnswers);
  const additionalInformation = answer.CrecerSurveys[0].additionalInformation || {};
  const { toPDF, targetRef } = usePDF({
    method: 'save',
    page: { margin: Margin.MEDIUM },
    filename: 'resultados-crecer-conectar.pdf',
  });

  React.useEffect(() => {
    scrollUp();
  }, []);

  const renderAdditionalAnswers = () => {
    if (additionalInformation?.additionalQuestions === 'leadersImmersion') {
      return leadersImmersionQuestions(additionalInformation);
    }
    return [];
  };

  return (
    <CrecerResultsContainer>
      <Button
        primary
        compact
        onClick={() => set_showAnswers(null)}
        style={{ display: 'block', margin: '10px 0' }}
      >
        Ir Atrás
      </Button>
      <div className="info">
        <p className="userdata">
          Encuesta de{' '}
          <strong>
            {answer.name} {answer.lastName}
          </strong>
        </p>
        <p className="userdata">
          Edad: <strong>{moment().diff(answer.birthdate, 'years')}</strong>
        </p>
        <p className="userdata">
          Genero: <strong>{answer.gender}</strong>
        </p>
        {answer.CrecerSurveys[0].parentName && answer.CrecerSurveys[0].parentPhone && (
          <div className="parents">
            <p>
              <strong>Acudiente</strong>
            </p>
            <p className="userdata">
              Nombre Acudiente: <strong>{answer.CrecerSurveys[0].parentName}</strong>
            </p>
            <p className="userdata">
              Teléfono Acudiente: <strong>{answer.CrecerSurveys[0].parentPhone}</strong>
            </p>
          </div>
        )}

        <p className="userdata">
          Teléfono: <strong>{answer.phone}</strong>
        </p>
        <p className="userdata">
          Identificación: <strong>{answer.identification}</strong>
        </p>
        <p className="userdata">
          Email: <strong>{answer.email}</strong>
        </p>
        {answer.CrecerSurveys[0].country && (
          <p className="userdata">
            País: <strong>{answer.CrecerSurveys[0].country}</strong>
          </p>
        )}

        <p className="userdata">
          Fecha de la encuesta:{' '}
          <strong>
            {moment.tz(answer.CrecerSurveys[0].createdAt, 'America/Bogota').format('DD-MM-YYYY')}
          </strong>
        </p>
      </div>

      <Button onClick={() => toPDF()}>Guardar resultados</Button>
      <div ref={targetRef} className="printable content">
        <h1>
          Encuestas de {answer.name} {answer.lastName}
        </h1>

        {!!DISCAnswers && !!Object.keys(DISCAnswers).length && DISCResults(DISCAnswers)}

        {!!experienceWithGodAnswers && !!Object.keys(experienceWithGodAnswers).length && (
          <section className="connecting result-section">
            <header className="result-section__header">
              <p className="result-section__eyebrow">Experiencia</p>
              <h2>La forma como te conectas con Dios</h2>
            </header>
            {showSpiritualGifts(sacredPath, experienceWithGodAnswers, 0)}
            {showSpiritualGifts(sacredPath, experienceWithGodAnswers, 1)}
            {showSpiritualGifts(sacredPath, experienceWithGodAnswers, 2)}
          </section>
        )}

        {!!spiritualGiftAnswers && !!Object.keys(spiritualGiftAnswers).length && (
          <section className="spiritual result-section">
            <header className="result-section__header">
              <p className="result-section__eyebrow">Dones</p>
              <h2>Los dones espirituales que Dios te ha dado</h2>
            </header>
            {showSpiritualGifts(spiritualGifts, spiritualGiftAnswers, 0)}
            {showSpiritualGifts(spiritualGifts, spiritualGiftAnswers, 1)}
            {showSpiritualGifts(spiritualGifts, spiritualGiftAnswers, 2)}
            {showSpiritualGifts(spiritualGifts, spiritualGiftAnswers, 3)}
          </section>
        )}
        {Object.keys(additionalInformation).length > 0 && (
          <div className="additional-info">
            <h2>Información Adicional</h2>
            {renderAnswers(renderAdditionalAnswers(), additionalInformation)}
          </div>
        )}
      </div>
    </CrecerResultsContainer>
  );
};
export default CrecerSurveyAnswers;
